import React from 'react'
import BreadCrumb from './BreadCrumb';
import RenewableEnergyListing from './RenewableEnergyListing';

function RenewableEnergyPage() {
    return ( 
        <>
            <BreadCrumb/>

            <RenewableEnergyListing />

            {/* <Herobottom /> */}
        </>
     );
}

export default RenewableEnergyPage;